/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU > INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	dropDownItem: {
        display: 'flex',
        alignItems: 'center',
        padding: replacePXinStringWithEM('16px 0'),
        height: pxToEm(16),
        fontSize: pxToEm(14),
        fontWeight: '500',
        color: theme.color.supporting.medium.swatch,
        background: theme.color.light.light.swatch,
        cursor: 'pointer',
        transition: 'all .15s',
        '& .item':{
            maxWidth: '20ch',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        '&:hover':{
            color: theme.color.primary.medium.swatch
        },
        '& .name-check':{
            height: pxToEm(24),
            width: pxToEm(24),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: pxToEm(4),
            fontSize:pxToEm(16),
            fontWeight: '900',
            marginRight: pxToEm(10)},
        '&.active-true':{
            color: theme.color.primary.medium.swatch,
            '& .name-check':{
                color: theme.color.light.light.swatch,
                background: theme.color.primary.medium.swatch,
            }
        },
        '&.active-false':{
            '& .name-check':{
                color: theme.color.supporting.light.swatch,
                background: theme.color.supporting.light.swatch,
                border: `${pxToEm(2)} solid #EEF2F6`
            }
        },
        '& .highlight':{
            fontWeight: '600',
            background: theme.color.primary.light.swatch
        }
    }
});